import React from 'react';

import UploadImgSrc from 'assets/icons/upload.svg';
import i18n from 'i18next';

type Props = {
  onClick?: () => void;
};

export default function UploadButton(props: Props) {
  return (
    <div className="absolute right-0 top-0 p-4" onClick={props.onClick}>
      <img
        src={UploadImgSrc}
        alt={i18n.t('common.remove')}
        className="bg-skyblue rounded-lg cursor-pointer"
      />
    </div>
  );
}
